import { useState } from "react";
import LoginForm from "../components/Authentication/LoginForm";
import SignupForm from "../components/Authentication/SignupForm";
import PhoneAuth from "../components/Authentication/PhoneAuthLogin";

export default function LoginPage() {

    const [activeTab, setActiveTab] = useState("loginWithPhone");

    return <div>
                <div className="loginImage">
                    <div className="loginDiv">
                        <div className="tabs">
                            <button
                                className={activeTab === "login" ? "active" : ""}
                                onClick={() => setActiveTab("loginWithPhone")}
                                >
                                Log in
                            </button> 
                            <button
                                className={activeTab === "signup" ? "active" : ""}
                                onClick={() => setActiveTab("signup")}
                                >
                                Sign up
                            </button>
                        </div>

                        {activeTab === "loginWithPassword" && (
                            <div className="loginDivBackgroundColor">
                                <div className="loginForm">
                                    <LoginForm />
                                </div>
                            </div>
                        )}

                        {activeTab === "loginWithPhone" && (
                            <div className="loginDivBackgroundColor">
                                <div className="loginForm">
                                    <PhoneAuth key={activeTab} mode={activeTab} />

                                    <div className="termsMessage">
                                        <p>
                                            We will send you a code to log in. Or you can
                                            <span
                                                className="textUnderline"
                                                onClick={() => setActiveTab("loginWithPassword")}
                                            > log in with a password</span> instead.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === "signup" && (
                            <div className="loginDivBackgroundColor">
                                <SignupForm activeTab={activeTab} setActiveTab={setActiveTab} />
                            </div>
                        )}
                       

                         
                    </div>
                </div>
            </div>;
}